export default class Status {
  public static None = 0
  public static Wait = 1
  public static Expedite = 2
  public static Done = 3
}
